// Section 19: Good harvest. 8% per season, Autumn bias. The harvest of the season it strikes is
// 1.3x. No choice. Constants: config.events['good-harvest'].
import type { Config } from '../../config';
import {
  effectDelta,
  effectParamModifiers,
  eventEntry,
  eventTurn,
} from '../../core/content-helpers';
import { defineEvent } from '../../core/registry';

export function goodHarvest(config: Config) {
  const c = config.events['good-harvest'];
  return defineEvent({
    id: 'good-harvest',
    label: 'Good harvest',
    section: 'S19',
    baseWeight: c.baseChance,
    seasons: ['autumn'],
    foreshadow: null,
    ledgerTag: null,
    weight: () => c.baseChance,
    text: () => eventEntry('good-harvest', { mul: c.harvestMul }),
    apply: (ctx) => [
      effectDelta('good-harvest', 'harvest', eventTurn(ctx) + 1, 1, { harvestMul: c.harvestMul }),
    ],
    choices: [],
    modifierTargets: ['harvestYield'],
    modifiers: effectParamModifiers,
  });
}
